import SearchUtility from "../utilities/search-utility";

class MainSearchCustomRender {
    static customRender(item)
    {
        item = SearchUtility.setTag(item), SearchUtility.setBreadcrumbs(item);
        if (item.recordObj.startDate) {
          if (item.recordObj.type == "Post") {
            item.recordObj.newsDateActive = true;
          }
          item.recordObj.startDateDisplay = new Date(
            item.recordObj.startDate
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        }
        return item;
    }
}

export default MainSearchCustomRender;